import { useDispatch } from "react-redux";
import { AppDispatch } from "reduxStore";

/**
 * @description Redux dispatch with types added
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
